module.exports = __webpack_public_path__ + "img/hwcloud.f83ab89c.png";